export enum ScheduleViewOfBoard {
  None = 0,
  All = 1,
  TBD = 2,
  TBDandDown = 3,
  AllButTBDandDown = 4
}

export const ScheduleViewOfBoardMapping: Record<ScheduleViewOfBoard, string> = {
  [ScheduleViewOfBoard.None]: 'None',
  [ScheduleViewOfBoard.All]: 'All',
  [ScheduleViewOfBoard.TBD]: 'TBD',
  [ScheduleViewOfBoard.TBDandDown]: 'TBD and Down',
  [ScheduleViewOfBoard.AllButTBDandDown]: 'All but TBD and Down'
};
